import React from 'react'
import { Text, TextProps, StyleSheet, StyleProp, ViewStyle, View, ViewProps } from 'react-native'

import { Color, Font, Radius, Spacing } from '../../style'

const styles = StyleSheet.create({
  container: {
    color: Color.premiumBlack,
  },
  skeletonContainer: {
    justifyContent: 'center',
  },
  skeletonContent: {
    backgroundColor: Color.sleepingGrey,
    borderRadius: Radius.S,
    minHeight: Spacing.S,
  },
})

export const TextStyles = {
  1: {
    fontSize: 32,
    lineHeight: 35,
    fontFamily: Font.regular,
    fontWeight: '600',
  },
  2: {
    fontSize: 24,
    lineHeight: 26,
    fontFamily: Font.regular,
    fontWeight: '600',
  },
  3: {
    fontSize: 24,
    lineHeight: 26,
    fontFamily: Font.light,
    fontWeight: '300',
  },
  4: {
    fontSize: 18,
    lineHeight: 26,
    fontFamily: Font.medium,
    fontWeight: '300',
  },
  5: {
    fontSize: 16,
    lineHeight: 22,
    fontFamily: Font.medium,
    fontWeight: '300',
  },
  6: {
    fontSize: 16,
    lineHeight: 22,
    fontFamily: Font.light,
  },
  7: {
    fontSize: 12,
    lineHeight: 22,
    fontFamily: Font.light,
  },
}

export type Level = keyof typeof TextStyles
//@ts-expect-error Object.keys expects a string to be used as key
export const Levels = Object.keys(TextStyles) as Level[]

export interface Props extends TextProps {
  level?: Level
}

const TypographyText = (props: Props) => {
  const { children, style, level, ...otherProps } = props
  const size = level || 6
  const textStyle = TextStyles[size]
  return (
    <Text style={[styles.container, textStyle, style]} {...otherProps}>
      {children}
    </Text>
  )
}

interface SkeletonProps extends ViewProps {
  numberOfLines?: number
  contentStyle?: StyleProp<ViewStyle>
  width?: number
  level?: Level
}

TypographyText.Skeleton = (props: SkeletonProps) => {
  const { numberOfLines = 1, contentStyle, width, level = 6, style, ...otherProps } = props

  const containerStyle = [
    styles.skeletonContainer,
    { width },
    numberOfLines === 1 && { height: TextStyles[level]?.lineHeight },
    style,
  ]
  return (
    <View style={containerStyle} {...otherProps}>
      {Array.from({ length: numberOfLines }).map((_, index) => (
        <View key={index} style={[styles.skeletonContent, index > 0 && { marginTop: Spacing.S }, contentStyle]} />
      ))}
    </View>
  )
}

export default TypographyText
